import React, { useEffect } from "react";
import { Form, Input, Button } from "antd";

const { TextArea } = Input;

interface ManageTicketProps {
  submitting: boolean;
  form: any;
  handleFinish: () => void;
  initialValues?: any;
}

export const ManageTicket = ({
  submitting,
  form,
  handleFinish,
  initialValues,
}: ManageTicketProps) => {
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        description: initialValues.description,
        dev_comment: initialValues.dev_comment,
        status: initialValues.status,
      });
    } else {
      form.resetFields();
      form.setFieldsValue({ status: "open" }); // Default for new tickets
    }
  }, [initialValues, form]);

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish}>
      {initialValues && (
        <div className="mb-4 text-gray-500 font-semibold">
          Ticket ID: {initialValues.ticket_number}
        </div>
      )}

      <Form.Item
        name="description"
        label="Description"
        rules={[{ required: true, message: "Please enter description" }]}
      >
        <TextArea rows={4} placeholder="Describe the issue" />
      </Form.Item>

      <div className="flex justify-end gap-2 mt-5">
        <Button onClick={() => form.resetFields()}>Reset</Button>
        <Button type="primary" htmlType="submit" loading={submitting}>
          {initialValues ? "Update Ticket" : "Create Ticket"}
        </Button>
      </div>
    </Form>
  );
};
